<template>
  <div>
    <v-row
      v-for="(info, i) in data.unit_info"
      :key="i"
      class="d-flex justify-space-between"
    >
      <v-col cols="5" class="py-0" style="min-width: 50%;">
        <v-card-text class="pb-0 pt-3" style="font-size: 14px;">
          {{ info.name }}
        </v-card-text>
      </v-col>
      <v-col cols="5" class="py-0" v-if="info.name === 'Current Destination'">
        <v-card-text
          class="pb-0 pt-3 font-weight-bold d-flex justify-end"
          style="font-size: 14px;"
        >
          {{ getGroupName(info.value) }}
        </v-card-text>
      </v-col>
      <v-col cols="6" class="py-0" v-if="info.name === 'Phone Number'">
        <v-card-text
          class="pb-0 pt-3 font-weight-bold d-flex justify-end"
          style="font-size:14px;"
        >
          {{ formatPhone(info.value) }}
        </v-card-text>
      </v-col>
      <v-col cols="6" class="py-0" v-else>
        <v-card-text
          class="pb-0 pt-3 font-weight-bold d-flex justify-end"
          style="font-size:14px;"
        >
          {{ info.value }}
        </v-card-text>
      </v-col>
    </v-row>
    <div class="d-flex justify-center pt-10">
      <v-btn
        large
        color="secondary"
        style="width: 90%;"
        @click="_setEditScreen(true)"
        >View Current Rental</v-btn
      >
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import ScreenDetailData from '@/mixins/ScreenDetailData';
import FormatPhone from '@/mixins/FormatPhone';

export default {
  mixins: [ScreenDetailData, FormatPhone],
  computed: {
    ...mapGetters({
      _client: 'account/getCurrentClient',
    }),
  },
  methods: {
    ...mapMutations({
      _setEditScreen: 'screens/setEditScreen',
    }),
    getGroupName(id) {
      let screenGroup = null;
      this._client.groups.map((group) => {
        if (group.uuid === id) {
          screenGroup = group;
        }
      });
      if (screenGroup) {
        return screenGroup.group_name;
      }
      return id;
    },
  },
};
</script>
